import { useTranslations } from 'next-intl';
import { BodyStrong, Button, Menu } from '@terra/ui-design-system';
import { ArrowDown01Icon } from '@terra/ui-icons';
import { MenuPanel } from '../../layout/MenuPanel';
import { TenantSwitchMenuContent } from '../../layout/target-selector/TenantSwitchSubmenu';

type LauncherTenantSelectProps = {
  tenantName: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export function LauncherTenantSelect({
  tenantName,
  isOpen,
  onOpenChange,
}: LauncherTenantSelectProps) {
  const t = useTranslations('proxy.workspaces');

  return (
    <Menu.Root
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={(details) => onOpenChange(details.open)}
      positioning={{ placement: 'bottom-start', gutter: 4 }}
    >
      <Menu.Trigger asChild>
        <Button
          variant="ghost"
          size="sm"
          h="7"
          px="2"
          gap="1"
          aria-label={t('tenantLabel')}
        >
          <BodyStrong as="span" data-bi-unmask="true">
            {tenantName}
          </BodyStrong>
          <ArrowDown01Icon size={14} aria-hidden="true" />
        </Button>
      </Menu.Trigger>
      <MenuPanel>
        <TenantSwitchMenuContent />
      </MenuPanel>
    </Menu.Root>
  );
}
